<template>
  <div class="card card-shadow" v-if="subtests.length > 0">
    <div class="card-header d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center">
      <h1 class="h4">{{ translate('tables.subtests.title') }}</h1>
      <div class="btn-toolbar mb-2 mb-md-0">
        <button class="btn btn-sm btn-primary" @click="showCreateSubtestModal">
          {{ translate('tables.subtests.create') }}
          <span class="fa fa-plus"></span>
        </button>
      </div>
    </div>
    <div class="card-body p-0">
      <table class="table card-table table-hover mb-0">
        <thead class="thead-light">
        <tr>
          <th>#</th>
          <th>{{ translate('tables.columns.test-type') }}</th>
          <th>{{ translate('tables.columns.subtest-type') }}</th>
          <th>{{ translate('tables.columns.test-variation') }}</th>
          <th>{{ translate('tables.subtests.columns.status') }}</th>
          <th>{{ translate('tables.subtests.columns.attempts') }}</th>
          <th>{{ translate('tables.columns.created') }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="eachSubtest in subtests"
            :class="subtest && (subtest.id === eachSubtest.id) ? 'table-info' : ''"
            @click="showSubtest(eachSubtest.id)">
          <td>{{ eachSubtest.id }}</td>
          <td>{{ eachSubtest.test_type.title }}</td>
          <td>{{ eachSubtest.subtest_type.title_de }}</td>
          <td>{{ eachSubtest.test_variation.title_de }}</td>
          <td>
              <span :class="subtestActiveClass(eachSubtest)">
                  {{ translate('statuses.' + (eachSubtest.active ? 'active' : 'inactive')) }}
              </span>
          </td>
          <td>{{ eachSubtest.subtest_attempts_count }}</td>
          <td>{{ eachSubtest.created_at | date }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div v-else class="alert alert-info w-50" role="alert">
    <span class="fa fa-info-circle mr-2"></span>{{ translate('tables.subtests.empty') }}
  </div>
</template>

<script>
export default {
  props: ['subtests', 'subtest'],

  data () {
    return {};
  },

  mounted () {
    this.$parent.$emit('getSubtests');
  },

  methods: {
    showSubtest (subtestId) {
      this.$parent.$emit('getSubtest', subtestId);
    },

    showCreateSubtestModal () {
      this.$parent.$emit('showCreateSubtestModal');
    },

    subtestActiveClass (eachSubtest) {
      return eachSubtest.active ? 'badge badge-success' : 'badge badge-secondary';
    },

    subtestAttemptStatusClass (subtestAttempt) {
      if (subtestAttempt.status === 'created') {
        return 'badge badge-secondary';
      }

      if (subtestAttempt.status === 'submitted') {
        return 'badge badge-info text-white';
      }

      if (subtestAttempt.status === 'in-review') {
        return 'badge badge-primary';
      }

      if (subtestAttempt.status === 'completed') {
        return 'badge badge-success';
      }
    },
  }
};
</script>
